import { render, staticRenderFns } from "./inputCom.vue?vue&type=template&id=059838d8&scoped=true"
import script from "./inputCom.vue?vue&type=script&lang=js"
export * from "./inputCom.vue?vue&type=script&lang=js"
import style0 from "./inputCom.vue?vue&type=style&index=0&id=059838d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059838d8",
  null
  
)

export default component.exports